export default {
  'memberSuspension.notice.title': 'Member Area',
  'memberSuspension.notice.heading': 'Member features are suspended',
  'memberSuspension.notice.description':
    'Your member features are currently suspended.',
  'memberSuspension.notice.contact':
    'Please contact store staff if you have any questions.',
  'memberSuspension.notice.provider': 'Powered by Echoss VIP',
  'memberSuspension.register.blocked':
    'Registration is unavailable. Please contact store staff.',
  'memberSuspension.login.blocked':
    'Login is unavailable. Please contact store staff.',
  'memberSuspension.asset.blocked':
    'This membership is suspended and cannot use offers or vouchers.',
  'memberSuspension.feature.blocked':
    'This member is suspended and cannot use this feature.',
} as Record<string, string>;
